import { IconButton, Button, ButtonProps, SxProps } from "@mui/material";
import { ReactNode } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { sxInvisibleStyle } from "./Style";
export interface IDeleteButtonProps {
  children?: ReactNode,
  visible?: boolean,
  sx?: SxProps,
  loading?: boolean,
  disabled?:boolean,
}

export default function DeleteButton({ children, loading, disabled, visible = true, sx, ...rest }: IDeleteButtonProps & ButtonProps) {
  if (children) {
    return <Button variant="text" color="error" disabled={loading || disabled} startIcon={<DeleteIcon />} sx={{ minWidth: '1.5rem', ...(!visible && { ...sxInvisibleStyle }), ...sx }} {...rest}>{children}</Button>
  }

  return (
    <IconButton {...rest} sx={{ minWidth: '1.5rem', ...(!visible && { ...sxInvisibleStyle }), ...sx }} color="error"><DeleteIcon /></IconButton>
  );
}
